import auchanCard from "../../../assets/svg/auchan-card.svg";
import culturaCard from "../../../assets/svg/cultura-card.svg";
import decathlonCard from "../../../assets/svg/decathlon-card.svg";
import leroyMerlinCard from "../../../assets/svg/leroymerlin-card.svg";

export interface Offer {
	/** URL slug, e.g. "auchan" → loyalty.leplein.fr/auchan */
	slug: string;
	/** Brand display name interpolated into the title (proper noun, same in every locale) */
	brand: string;
	/** i18n key prefix in the `loyalty` namespace, e.g. "auchanKwh" → t("auchanKwh.headline") */
	i18nKey: "auchan" | "auchanKwh" | "auchanKwhBoostX2" | "decathlon" | "leroyMerlin" | "cultura";
	/** Help-center article opened by the "Voir toutes les conditions" button. `null` until the offer goes live → CTA disabled. */
	conditionsUrl: string | null;
	/** Brand loyalty-card illustration. `null` → placeholder is rendered. */
	imageSrc: string | null;
}

export const OFFERS: Record<string, Offer> = {
	auchan: {
		slug: "auchan",
		brand: "Auchan",
		i18nKey: "auchan",
		conditionsUrl: "https://aide.leplein.fr/fr/article/programme-de-fidelite-auchan-12m4w3o/",
		imageSrc: auchanCard,
	},
	"auchan-kwh": {
		slug: "auchan-kwh",
		brand: "Auchan",
		i18nKey: "auchanKwh",
		conditionsUrl: null,
		imageSrc: auchanCard,
	},
	"auchan-kwh-boost-x2": {
		slug: "auchan-kwh-boost-x2",
		brand: "Auchan",
		i18nKey: "auchanKwhBoostX2",
		conditionsUrl: "https://aide.leplein.fr/fr/article/operation-exceptionnelle-cagnottage-double-1vnuvz6/",
		imageSrc: auchanCard,
	},
	decathlon: {
		slug: "decathlon",
		brand: "Decathlon",
		i18nKey: "decathlon",
		conditionsUrl: "https://aide.leplein.fr/fr/article/programme-de-fidelite-decathlon-rkt2xl/",
		imageSrc: decathlonCard,
	},
	"leroy-merlin": {
		slug: "leroy-merlin",
		brand: "Leroy Merlin",
		i18nKey: "leroyMerlin",
		conditionsUrl: "https://aide.leplein.fr/fr/article/programme-de-fidelite-leroy-merlin-1q8bpcr/",
		imageSrc: leroyMerlinCard,
	},
	cultura: {
		slug: "cultura",
		brand: "Cultura",
		i18nKey: "cultura",
		conditionsUrl: null,
		imageSrc: culturaCard,
	},
};

export const getOffer = (slug: string): Offer | undefined => OFFERS[slug];
